module.exports = __webpack_public_path__ + "img/lidaoLogo.4b086e4e.png";